import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	list: [],
	fetch: false,
	confirmed: false,
	countdown: "",
};

const userMailsSlice = createSlice({
	name: "user_mails",
	initialState: initialState,
	reducers: {
		get: (state) => {
			state.fetch = true;
			if (!state.countdown) {
				let d = new Date();
				d = new Date(d.getTime() + 30000);
				state.countdown = d;
			}
		},
		set: (state, action) => {
			state.list = action.payload.list;
			state.confirmed = action.payload.confirmed;
			state.fetch = false;
		},
		drop: (state) => {
			state.list = [];
			state.fetch = false;
			state.confirmed = false;
		},
		sendMail: (state) => {
			let d = new Date();
			d = new Date(d.getTime() + 30000);
			state.countdown = d;
		},
	},
});

export const userMailsActions = userMailsSlice.actions;
export const userMailsReducer = userMailsSlice.reducer;
